(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["artworx-quote-form"] && !Shopify.designMode) return;
  try {
    function initializeArtworxQuoteForm() {
    const form = document.getElementById('artworx-quote');
    if (!form || form.dataset.initialized === 'true') return;

    form.dataset.initialized = 'true';
    const startedAt = form.querySelector('#aw-started-at');
    const status = form.querySelector('#aw-form-status');
    const submitButton = form.querySelector('.aw-submit');
    startedAt.value = String(Date.now());

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      status.hidden = true;
      status.textContent = '';
      status.classList.remove('aw-form-status--success', 'aw-form-status--error');
      submitButton.disabled = true;
      submitButton.textContent = form.dataset.sending;

      const payload = Object.fromEntries(new FormData(form).entries());

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || !result.ok) {
          throw new Error(result.error || form.dataset.error);
        }

        status.textContent = form.dataset.success;
        status.classList.add('aw-form-status--success');
        status.hidden = false;
        form.reset();
        startedAt.value = String(Date.now());
        status.focus();
      } catch (error) {
        status.textContent = error && error.name === 'AbortError' ? form.dataset.timeout : (error instanceof Error && error.message !== 'Failed to fetch' ? error.message : form.dataset.error);
        status.classList.add('aw-form-status--error');
        status.hidden = false;
        status.focus();
      } finally {
        clearTimeout(timer);
        submitButton.disabled = false;
        submitButton.textContent = submitButton.dataset.defaultLabel;
      }
    });
  }

  initializeArtworxQuoteForm();
  document.addEventListener('shopify:section:load', initializeArtworxQuoteForm);
  } catch(e) { console.error(e); }
})();

})();
